import React from 'react'
import { GridApi } from 'ag-grid-community'
import { TextFlagButtonsContainer, getTextFlagButtonState, ToolbarTextFlagButton } from 'view/components/buttons'
import { Locale, Translation } from 'locale'
import { TradingEntityDefaultsGridColumnId } from './tradingEntityDefaultsGridModel'

export enum TradingEntityDefaultsGroupByOptions {
  MY_ENTITY = 'MY_ENTITY',
  COUNTERPARTY = 'COUNTERPARTY'
}

export interface TradingEntityDefaultsGroupByTogglesProps {
  gridApi: GridApi | null
}

export const TradingEntityDefaultsGroupByToggles: React.FunctionComponent<TradingEntityDefaultsGroupByTogglesProps> = props => {
  const { gridApi } = props

  let groupByValue = TradingEntityDefaultsGroupByOptions.MY_ENTITY
  const rowGroupColumns = gridApi?.getRowGroupColumns()
  if (
    rowGroupColumns?.length === 1 &&
    rowGroupColumns[0].getColId() === TradingEntityDefaultsGridColumnId.TRADING_ENTITY_DEFAULTS_MY_ENTITY
  ) {
    groupByValue = TradingEntityDefaultsGroupByOptions.MY_ENTITY
  } else if (
    rowGroupColumns?.length === 1 &&
    rowGroupColumns[0].getColId() === TradingEntityDefaultsGridColumnId.TRADING_ENTITY_DEFAULTS_COUNTERPARTY
  ) {
    groupByValue = TradingEntityDefaultsGroupByOptions.COUNTERPARTY
  }

  const handleUpdateGroupByValue = (option: TradingEntityDefaultsGroupByOptions) => {
    if (!gridApi) {
      return
    }
    if (option === TradingEntityDefaultsGroupByOptions.MY_ENTITY) {
      gridApi.setRowGroupColumns([TradingEntityDefaultsGridColumnId.TRADING_ENTITY_DEFAULTS_MY_ENTITY])
      gridApi.setColumnsVisible([TradingEntityDefaultsGridColumnId.TRADING_ENTITY_DEFAULTS_MY_ENTITY], false)
      gridApi.setColumnsVisible([TradingEntityDefaultsGridColumnId.TRADING_ENTITY_DEFAULTS_COUNTERPARTY], true)
    } else if (option === TradingEntityDefaultsGroupByOptions.COUNTERPARTY) {
      gridApi.setRowGroupColumns([TradingEntityDefaultsGridColumnId.TRADING_ENTITY_DEFAULTS_COUNTERPARTY])
      gridApi.setColumnsVisible([TradingEntityDefaultsGridColumnId.TRADING_ENTITY_DEFAULTS_COUNTERPARTY], false)
      gridApi.setColumnsVisible([TradingEntityDefaultsGridColumnId.TRADING_ENTITY_DEFAULTS_MY_ENTITY], true)
    } else {
      throw new Error(`Unhandled TradingEntityDefaultsGroupByOption ${[option]}`)
    }
    gridApi.applyColumnState({ defaultState: { sort: null } })
  }

  return (
    <TextFlagButtonsContainer>
      <ToolbarTextFlagButton
        dataTestId={'StagingGroupByToggles-ToolbarTextFlagButton-Ungrouped'}
        state={getTextFlagButtonState(groupByValue === TradingEntityDefaultsGroupByOptions.MY_ENTITY)}
        onClick={() => handleUpdateGroupByValue(TradingEntityDefaultsGroupByOptions.MY_ENTITY)}>
        {Locale.translate(Translation.TC_MY_ENTITY)}
      </ToolbarTextFlagButton>
      <ToolbarTextFlagButton
        dataTestId={'StagingGroupByToggles-ToolbarTextFlagButton-GroupingCollections'}
        state={getTextFlagButtonState(groupByValue === TradingEntityDefaultsGroupByOptions.COUNTERPARTY)}
        onClick={() => handleUpdateGroupByValue(TradingEntityDefaultsGroupByOptions.COUNTERPARTY)}>
        {Locale.translate(Translation.TC_COUNTERPARTY)}
      </ToolbarTextFlagButton>
    </TextFlagButtonsContainer>
  )
}
